import { FC, useCallback, useEffect, useState } from 'react'
import { Box, Typography } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch } from '../../../../../../store'
import { MatchedPFsActions, MatchedPFsSelectors } from '../../../../../../store/matchedPFs'
import { useParams } from 'react-router-dom'
import { PFAccordion } from './PFAccordion'
import { RightSlider } from '../../../../../../components/sliders'
import { PFGrantForm } from './PFGrantForm'

export const PrivateFoundations: FC = () => {
  const { projectId = '' } = useParams()

  const dispatch = useDispatch<AppDispatch>()

  const [showGrantForm, setShowGrantForm] = useState(false)
  const [selectedPF, setSelectedPF] = useState({ pfTitle: '', matchedPFId: '' })

  const pfs = useSelector(MatchedPFsSelectors.makeMatchedPFs)

  const fetchPFs = useCallback(() => {
    if (projectId) {
      dispatch(MatchedPFsActions.fetchTechMatchedPFsAsync({
        technologyId: projectId,
        options: { params: { $includes: 'privateFoundation, grants' } },
      }));
    }
  }, [projectId, dispatch]);

  useEffect(() => {
    fetchPFs()
  }, [fetchPFs])

  const handleGrantFormSlideOut = (matchedPFId: string, pfTitle: string) => {
    setSelectedPF({ matchedPFId, pfTitle })
    setShowGrantForm(true)
  }

  const handleSlideOutCloseAction = () => {
    setSelectedPF({ matchedPFId: '', pfTitle: '' })
    setShowGrantForm(false)
  }

  const handleGrantSucess = () => {
    fetchPFs()
    setShowGrantForm(false)
  }

  return (
    <Box>
      <RightSlider
        open={showGrantForm}
        setOpen={setShowGrantForm}
        outerBoxSx={{ maxWidth: '600px' }}
        closeButtonAction={handleSlideOutCloseAction}
      >
        <PFGrantForm
          projectId={projectId}
          title={selectedPF.pfTitle}
          matchedPFId={selectedPF.matchedPFId}
          onSuccess={handleGrantSucess}
        />
      </RightSlider>

      <Typography mb={2} color="secondary" fontSize="1rem" fontWeight={600}>
        Private foundations
      </Typography>

      {
        pfs && pfs.map(pf => <PFAccordion
            key={pf._id}
            grants={pf.grants}
            taxYear={pf.taxYear}
            title={pf.organizationName}
            website={pf.organizationUrl}
            description={pf.organizationDescription}
            financialContributions={pf.formattedCharityAmount}
            handleGrantFormSlideOut={(e) => {
              e.stopPropagation()
              handleGrantFormSlideOut(pf.matchedPFId, pf.organizationName)
            }}
          />,
        )
      }
    </Box>
  )
}